/* ---------------------------------------------------------------------------
   ab-bundle-sub.js   TEST THEME ONLY

   Buy box for the Founders Collection, built to Joel's spec:

     One-time purchase   one line in the cart, the bundle itself, $1,000.
     Subscribe & save    two lines, the same bundle plus the one product the
                         customer is subscribing to. Still $1,000 today,
                         because that product's selling plan takes 100% off the
                         first order. From the second month only that product
                         is billed, at $128.99 instead of $325.

   The bundle is added as a bundle. It is not broken into its children here, so
   the cart shows what the customer bought rather than a parts list.

   There is no discount anywhere in this. Both options cost the same on the
   first order, and the drop to $128.99 is the selling plan's own after-cycle
   adjustment. An earlier version restored the price with a discount code and
   then with a Shopify Function; neither is needed once both options are $1,000.

   Two things in this theme fight back and are handled here:
     - Loop's widget clones the add-to-cart button to strip listeners off it
     - abv4-vanilla.js re-renders the buy box, detaching any listener bound to
       the button node, so everything below is delegated from document in the
       capture phase instead

   To point this at the real products later, only CONFIG changes.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CONFIG = {
    handle: 'test-parent',

    /* the bundle, bought on both paths */
    bundleVariant: 67647061590112,

    /* added only on the subscription path, carries the plan */
    subscriptionVariant: 67647061786720,
    sellingPlan: 8660975712,

    /* what the customer pays today, the same either way */
    total: 100000,

    /* what the subscribed product costs from the second month */
    recurringMonthly: 12899
  };

  var busy = false;

  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function onPage() {
    return window.location.pathname.indexOf('/products/' + CONFIG.handle) !== -1;
  }
  function each(sel, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), fn);
  }
  function subSelected() {
    var el = document.querySelector('input[name="abx-purchase"]:checked');
    return !!el && el.value === 'subsave';
  }
  function postJson(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  }

  function removeLoopWidget() {
    ['[id^="loop-widget-container"]', '[id^="loop-widget-skeleton"]', '[id*="loop_subscriptions_loop_widget"]']
      .forEach(function (s) { each(s, function (el) { el.remove(); }); });
  }

  /* the theme's own rc- chooser describes the parent variant, not the offer */
  function hideThemeChooser() {
    each('.rc-container-wrapper', function (el) {
      if (!el.classList.contains('abx-purchase-options')) el.style.display = 'none';
    });
  }

  function buildOptions() {
    var wrap = document.createElement('div');
    wrap.className = 'rc-container-wrapper abx-purchase-options';
    wrap.innerHTML =
      '<div class="rc-onetime"><div class="rc-radio-onetime">' +
        '<input type="radio" id="abx-onetime" name="abx-purchase" value="onetime" checked>' +
        '<label class="rc-radio-label" for="abx-onetime">' +
          '<span class="rc-option-text">One-time purchase</span> ' +
          '<span class="rc-option-price">' + money(CONFIG.total) + '</span>' +
        '</label></div></div>' +
      '<div class="rc-subsave"><div class="rc-radio-subsave">' +
        '<input type="radio" id="abx-subsave" name="abx-purchase" value="subsave">' +
        '<label class="rc-radio-label" for="abx-subsave">' +
          '<span class="rc-option-text">Subscribe &amp; save</span> ' +
          '<span class="rc-option-price">' + money(CONFIG.total) + '</span>' +
        '</label></div>' +
        '<div class="abx-sub-note">Same price today. Then ' + money(CONFIG.recurringMonthly) +
          ' a month for the X Box. Cancel anytime.</div></div>';
    return wrap;
  }

  /* re-queries the button every time, because the theme replaces it */
  function paint() {
    var btn = document.querySelector('.add-to-cart-button');
    if (!btn) return;
    var price = btn.querySelector('.price');
    var caption = btn.querySelector('.caption');
    if (price) price.innerHTML = money(CONFIG.total);
    if (caption) caption.textContent = subSelected() ? 'Add Subscription to Cart' : 'Add to Cart';
    btn.setAttribute('type', 'button');
  }

  function payload() {
    var items = [];

    /* the cart lists its lines newest first, so the subscribed item is posted
       BEFORE the bundle to make the bundle appear above it on the cart page */
    if (subSelected()) {
      items.push({
        id: CONFIG.subscriptionVariant,
        quantity: 1,
        selling_plan: CONFIG.sellingPlan
      });
    }
    items.push({ id: CONFIG.bundleVariant, quantity: 1 });

    return { items: items };
  }

  function showError(msg) {
    var btn = document.querySelector('.add-to-cart-button');
    if (!btn) return;
    var n = document.querySelector('.abx-error');
    if (!n) {
      n = document.createElement('div');
      n.className = 'abx-error';
      btn.parentNode.appendChild(n);
    }
    n.textContent = msg;
  }

  function addToCart() {
    if (busy) return;
    busy = true;
    showError('');

    /* start from an empty cart so nothing from a previous attempt survives */
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () { return postJson('/cart/add.js', payload()); })
      .then(function (res) {
        /* the theme's own engine never reads this body, which is why a 422
           showed up as nothing happening at all. Read it and say so. */
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || ('HTTP ' + res.status));
          return body;
        });
      })
      /* nothing is applied here, but a code the customer picked up earlier in
         the session would otherwise sit on top of the cart */
      .then(function () { return postJson('/cart/update.js', { discount: '' }); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        busy = false;
        console.error('[abx] add to cart failed:', err);
        showError('Could not add to cart: ' + err.message);
      });
  }

  function mount() {
    if (!onPage()) return;
    removeLoopWidget();
    hideThemeChooser();
    var group = document.querySelector('.add-to-cart-group');
    if (group && !document.querySelector('.abx-purchase-options')) {
      group.parentNode.insertBefore(buildOptions(), group);
    }
    paint();
  }

  /* delegated from document in the CAPTURE phase, so it fires before any
     listener the theme or Loop binds, and survives the buy box re-rendering */
  document.addEventListener('click', function (e) {
    if (!onPage()) return;
    var btn = e.target && e.target.closest ? e.target.closest('.add-to-cart-button') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    addToCart();
  }, true);

  document.addEventListener('submit', function (e) {
    if (!onPage()) return;
    if (e.target && e.target.classList && e.target.classList.contains('v4-add-to-cart-form')) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (!onPage()) return;
    if (e.target && e.target.name === 'abx-purchase') paint();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  var ticks = 0;
  var iv = setInterval(function () { mount(); if (++ticks > 20) clearInterval(iv); }, 500);
})();
